// extracted by mini-css-extract-plugin
export default {"buttonStyle":"Button_buttonStyle__3n00p","buttonStylePreview":"Button_buttonStylePreview__VW5BR","buttonHover":"Button_buttonHover__wihtu"};